import { NgModule } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {
  AgrPageToolbarModule,
  AgrValueRowModule,
  AgrLogoWideModule,
} from '@next/core-lib/components';
import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SharedModule } from '../shared/shared.module';
import { ManualSoilAnalysisDialogComponent } from './components/manual-soil-analysis-dialog/manual-soil-analysis-dialog.component';
import { SoilAnalysisDialogComponent } from './components/soil-analysis-dialog/soil-analysis-dialog.component';
import { SoilAnalysisListComponent } from './components/soil-analysis-list/soil-analysis-list.component';
import { SoilAnalysisEffects } from './store/soil-analysis.effects';
import { soilAnalysisReducer } from './store/soil-analysis.reducer';

@NgModule({
  imports: [
    SharedModule,
    MatListModule,
    AgrDialogModule,
    MatIconModule,
    MatExpansionModule,
    MatDividerModule,
    MatFormFieldModule,
    AgrFormModule,
    MatInputModule,
    MatDatepickerModule,
    AgrPageToolbarModule,
    AgrValueRowModule,
    AgrLogoWideModule,
    MatProgressSpinnerModule,
  ],
  providers: [
    provideEffects([SoilAnalysisEffects]),
    provideState('soilAnalysis', soilAnalysisReducer),
  ],
  declarations: [
    SoilAnalysisListComponent,
    SoilAnalysisDialogComponent,
    ManualSoilAnalysisDialogComponent,
  ],
  exports: [SoilAnalysisListComponent],
})
export class SoilAnalysisModule {}
